export const BOTNAME_LABEL="BuckeyeBot"
export const OSU_CHAT_ARIA_REGION="OSUCHATARIAREGION"